<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { initDetail, record, resetPassword, save, passwordChangedMessage } from "./user.store";
  import PortalRoleDropdown from "../../components/Form/Fields/Dropdown/PortalRoleDropdown.svelte";
  import Button from "../../components/Button.svelte";
  import Label from "../../components/Form/Label.svelte";
  import PortalUserTypeDropdown from "../../components/Form/Fields/Dropdown/PortalUserTypeDropdown.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: newUserPasswordSet = !isNew || ($record != null && $record.newPassword != "");
  $: canSubmit = $record != null && $record.lastName != "" && $record.firstName != "" && $record.email != "" && newUserPasswordSet;

  async function onSubmit() {
    let newP = isNew;
    let _resp = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/user/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/user`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
      <div class="columns">
        <div class="column">
          <FormField>
            <Input name="Last Name" placeholder="last name" required={true} bind:value={$record.lastName} />
          </FormField>
        </div>

        <div class="column">
          <FormField>
            <Input name="First Name" placeholder="first name" required={true} bind:value={$record.firstName} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <FormField>
            <Input name="e-mail" placeholder="e-mail" required={true} bind:value={$record.email} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <Switch name="Active" bind:value={$record.active} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <Switch name="Show score" bind:value={$record.showScore} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <FormField>
            <PortalRoleDropdown name="Role" placeholder="role" bind:value={$record.portalRoleId} />
          </FormField>
        </div>

        <div class="column">
          <FormField>
            <PortalUserTypeDropdown name="User Type" placeholder="type" bind:value={$record.portalUserTypeId} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          {#if isNew}
            <FormField>
              <Input name="New Password" placeholder="" type="password" required={true} bind:value={$record.newPassword} />
            </FormField>
          {:else}
            <div class="field">
              <Label>Reset Password</Label>

              <div class="field has-addons">
                <p class="control has-icons-right">
                  <Input name="" placeholder="" type="password" required={false} bind:value={$record.newPassword} />

                  <span class="icon is-small is-right">
                    <i class="delete" on:click={(_) => ($record.newPassword = "")} />
                  </span>
                </p>

                <p class="control">
                  <Button on:click={resetPassword}>
                    <span>Reset Password</span>
                  </Button>
                </p>
              </div>
            </div>

            {#if $passwordChangedMessage != ""}
              <article class="message is-warning">
                <div class="message-body">
                  {$passwordChangedMessage}
                </div>
              </article>
            {/if}
          {/if}
        </div>
      </div>
    </FormLayout>
  {/if}
</MainLayout>
